// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { findDOMNode, Component, Children } from '../../utils';
import PropTypes from 'prop-types';

/**
 * AutoClosable component.
 */
class AutoClosable extends Component {
    constructor(props) {
        super(props);

        this.onOutsideClick = this.onOutsideClick.bind(this);
    }

    componentDidMount() {
        document.body.addEventListener('click', this.onOutsideClick);
    }

    componentWillUnmount() {
        document.body.removeEventListener('click', this.onOutsideClick);
    }

    onOutsideClick(event) {
        const { ignoreNodes } = this.props;
        const nodes = typeof ignoreNodes === 'function' ? ignoreNodes() : [];
        nodes.push(this);

        if (nodes.map(findDOMNode).some(node => node && node.contains(event.target))) {
            return;
        }

        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {
        return Children.only(this.props.children);
    }
}
AutoClosable.propTypes = {
    /**
     * onClose handler
     */
    onClose: PropTypes.func,
    /**
     * Content of the AutoClosable
     */
    children: PropTypes.element.isRequired,
    /**
     * Optional function that returns an array of DOM nodes clicks on which should be ignored.
     * @ignore
     */
    ignoreNodes: PropTypes.func,
};
AutoClosable.defaultProps = {
    onClose: null,
    ignoreNodes: null,
};

export default AutoClosable;



// WEBPACK FOOTER //
// ./components/AutoClosable/AutoClosable.js